import { render, staticRenderFns } from "./ModalCustomerRecurring.vue?vue&type=template&id=0476e2d4"
import script from "./ModalCustomerRecurring.vue?vue&type=script&lang=js"
export * from "./ModalCustomerRecurring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports